import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private readonly http: HttpClient) {
    console.log('UserService initialized');
    const domain = window.sessionStorage.getItem("Domain");
    console.log('Domain', domain)
  }

  private get ticketApi(): string {
    const domain = window.sessionStorage.getItem("Domain");
    if (domain === 'L') {
      return environment.liveURL;
    } else {
      return environment.ticketAPI;
    }
  }

  async authenticateAndStoreUserData(email: string): Promise<void> {
    try {

      const domain = window.sessionStorage.getItem("Domain");
      if (!domain) {
        console.error('[UserService] Domain not set in sessionStorage.');
        throw new Error('Domain not set in sessionStorage.');
      }

      let url = '';
      if (domain === "L") {
        url = 'https://login.teamleaseregtech.com/apadr';
      } else if (domain === "D") {
        url = 'https://uat.avantisregtec.in/TRLPLWeb_API'; 
      } else if (domain === "U" || domain === "LO") {
        url = 'https://uat.avantisregtec.in/TRLPLWeb_API';
      } else {
        console.error('[UserService] Unknown domain code:', domain);
        throw new Error('Unknown domain code in sessionStorage.');
      }

      const internationalEntityDemoEmailIDs = ['performer@regtrack.com', 'reviewer@regtrack.com', 'mgmt@regtrack.com', 'management@regtrack.com'];

      if (internationalEntityDemoEmailIDs.includes(email)) {
        console.log('[UserService] International entity demo email detected.');

        switch (email) {
          case 'performer@regtrack.com':
              sessionStorage.setItem('userName', "Performer  Regtrack");
              sessionStorage.setItem('userID', "56258");
              sessionStorage.setItem('emailAddress', email);
            break;
          case 'reviewer@regtrack.com':
              sessionStorage.setItem('userName', "Reviewer Regtrack");
              sessionStorage.setItem('userID', "56259");
              sessionStorage.setItem('emailAddress', email); 
            break;
          case 'mgmt@regtrack.com':
              sessionStorage.setItem('userName', "Mgmt Regtrack");
              sessionStorage.setItem('userID', "56260");
              sessionStorage.setItem('emailAddress', email);
            break;
          case 'management@regtrack.com':
              sessionStorage.setItem('userName', "Management Demo");
              sessionStorage.setItem('userID', "56261");
              sessionStorage.setItem('emailAddress', email);
            break;
          default:
            console.error('[UserService] Unknown international entity demo email:', email);
            throw new Error('Unknown international entity demo email.');
        }


      } else {
        const tokenResponse: any = await this.http.get(`${url}/Data/GetTokenLoginUserMobile`).toPromise();
        const token = tokenResponse[0]?.tokendetail;
        if (!token) throw new Error('Token not received');

        const userUrl = `${url}/Data/GetUserByEmail?emailId=${encodeURIComponent(email)}`;
        const headers = new HttpHeaders({
          'Authorization': token
        });

        const userData: any = await this.http.post(userUrl, {}, { headers }).toPromise();

        if (!userData?.userName || !userData?.userID) {
          console.error('[UserService] Incomplete user data received:', userData);
          throw new Error('Incomplete user data received.');
        }

        sessionStorage.setItem('userName', userData.userName);
        sessionStorage.setItem('userID', userData.userID.toString());
        sessionStorage.setItem('emailAddress', email);
      }



    } catch (error) {
      console.error('Error during authentication or user data fetching:', error);
      throw error;
    }
  }

  validateUser(): Observable<any> {
    return this.http.post(
      `${this.ticketApi}/token/`,
      { "encrypted_data": "PML1vlvKDsKCLabedmnshwuE3y0TdWxxg2D+83T88Ho=" },
    )
  }

  decryptCookieDataAndSetSessionData(cookie: string): Observable<any> {
    const authToken = sessionStorage.getItem('auth_token');
    if (!authToken) {
      console.error('[UserService] Session expired or missing required session data.');
      throw new Error('Session expired or missing required session data. Please log in again.');
    }

    return this.http.post(
      `${this.ticketApi}/decrypt/`,
      {
        "encrypted_value": cookie
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${authToken}`
        })
      }
    );
  }

}
